import _memoize from 'lodash/memoize';
import { FULL_HD, HD, safetyMargins, RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { makeDefaultStylingContext } from '../utils/style';
import { sizes as heroPoserSizes } from './heroNav/heroNav.style';
import { sizes, templates, imageOptions } from './hero.constants';

export { sizes } from './hero.constants';

export const defaultContext = makeDefaultStylingContext();

// Distance between neighbor horizontal list items
export const CONTENT_GAP = {
  [HD]: 12,
  [FULL_HD]: 12,
};

export const HEIGHT = {
  [HD]: sizes[templates.Hero][RENDERING_CONTEXT.GENERAL][HD].h,
  [FULL_HD]: sizes[templates.Hero][RENDERING_CONTEXT.GENERAL][FULL_HD].h,
};

export const PADDING_BOTTOM = {
  [HD]: 24,
  [FULL_HD]: 32,
};

// Padding between container edges and a content inside: horizontal list of items and metadata
export const PADDING_LEFT = {
  [HD]: 32,
  [FULL_HD]: 40,
};

export const METADATA_PADDING_BOTTOM = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const BACKGROUND_CONTENT_OFFSET = {
  [HD]: 40,
  [FULL_HD]: 40,
};

export const getItemsTop = _memoize(
  screenSize => HEIGHT[screenSize] - PADDING_BOTTOM[screenSize] - heroPoserSizes[screenSize].h,
);

export const getMetadataBottom = _memoize(screenSize => getItemsTop(screenSize) - METADATA_PADDING_BOTTOM[screenSize]);

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize } = context;
  const itemsTop = getItemsTop(screenSize);
  const metadataBottom = getMetadataBottom(screenSize);
  const size = sizes[templates.Hero][RENDERING_CONTEXT.GENERAL][screenSize];
  const backgroundSize = imageOptions[templates.Hero][RENDERING_CONTEXT.GENERAL][screenSize].PRIMARY;
  const background = {
    w: backgroundSize.width,
    h: backgroundSize.height,
    x: size.w,
    mountX: 1,
  };

  return {
    ...size,
    Background: { ...background },
    Gradient: { ...background },
    Metadata: {
      mountY: 1,
      h: metadataBottom,
      y: metadataBottom,
    },
    Items: {
      y: itemsTop,
      rightPadding: safetyMargins.horizontal[screenSize],
    },
  };
};
